// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    inventory_find_materials: 'Buscando en el almacén',
    inventory_material_detail: 'Leyendo la ficha de un material',
    inventory_where_is: 'Buscando dónde está',
    inventory_stock_summary: 'Sumando el almacén',
    inventory_find_deliveries: 'Buscando entre los albaranes',
    inventory_move_stock: 'Moviendo stock',
  },
  ca: {
    inventory_find_materials: 'Cercant al magatzem',
    inventory_material_detail: 'Llegint la fitxa d’un material',
    inventory_where_is: 'Buscant on és',
    inventory_stock_summary: 'Sumant el magatzem',
    inventory_find_deliveries: 'Cercant entre els albarans',
    inventory_move_stock: 'Movent estoc',
  },
  en: {
    inventory_find_materials: 'Looking through the warehouse',
    inventory_material_detail: 'Reading a material card',
    inventory_where_is: 'Locating something',
    inventory_stock_summary: 'Adding up the warehouse',
    inventory_find_deliveries: 'Looking through the delivery notes',
    inventory_move_stock: 'Moving stock',
  },
  fr: {
    inventory_find_materials: 'Recherche dans l’entrepôt',
    inventory_material_detail: 'Lecture de la fiche d’un article',
    inventory_where_is: 'Localisation',
    inventory_stock_summary: 'Bilan de l’entrepôt',
    inventory_find_deliveries: 'Recherche parmi les bons de livraison',
    inventory_move_stock: 'Mouvement de stock',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
